import React from 'react'
import { styled } from '@mui/material'
import MultiplePartTabForm from '../form/MultiplePartTabForm'
import { TabbedMultiCardFormProps } from '../form/type'

const TabbedShowLayoutStyled = styled(MultiplePartTabForm)(() => ({
  width: '100%',
  '& .MuiCardContent-root': {
    paddingLeft: 0,
    paddingRight: 0,
  },
}))

export const TabbedMultiCardForm: React.FC<TabbedMultiCardFormProps> = ({
  children,
  record = { id: null },
  syncWithLocation = false,
  ...props
}) => {
  return (
    <TabbedShowLayoutStyled record={record} syncWithLocation={syncWithLocation} {...props}>
      {children}
    </TabbedShowLayoutStyled>
  )
}
